'use client';
import React from 'react';
import Link from 'next/link';

export default function MasjidFooter() {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=Amiri:wght@400;700&display=swap');
        .mih-footer {
          background: #030810;
          border-top: 1px solid rgba(255,255,255,0.06);
          padding: 56px 32px 32px;
        }
        .mih-footer-inner {
          max-width: 1320px;
          margin: 0 auto;
        }
        .mih-footer-top {
          display: grid;
          grid-template-columns: 1.5fr 1fr 1fr 1fr;
          gap: 40px;
          margin-bottom: 48px;
          padding-bottom: 40px;
          border-bottom: 1px solid rgba(255,255,255,0.06);
        }
        .mih-footer-brand-ar {
          font-family: 'Amiri', serif;
          font-size: 22px;
          color: rgba(255,255,255,0.5);
          direction: rtl;
          display: block;
          margin-bottom: 6px;
        }
        .mih-footer-brand-en {
          font-family: monospace;
          font-size: 9px;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          color: rgba(255,255,255,0.2);
          display: block;
          margin-bottom: 14px;
        }
        .mih-footer-brand-body {
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          color: rgba(255,255,255,0.3);
          line-height: 1.7;
          margin-bottom: 16px;
        }
        .mih-footer-subhaal-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 6px 12px;
          border: 1px solid rgba(37,99,235,0.2);
          background: rgba(37,99,235,0.06);
        }
        .mih-footer-subhaal-dot {
          width: 5px; height: 5px;
          border-radius: 50%;
          background: #3b82f6;
        }
        .mih-footer-subhaal-text {
          font-family: monospace;
          font-size: 7px;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          color: rgba(255,255,255,0.25);
        }
        .mih-footer-col-title {
          font-family: monospace;
          font-size: 8px;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          color: rgba(255,255,255,0.25);
          margin-bottom: 14px;
        }
        .mih-footer-links {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        .mih-footer-link {
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          color: rgba(255,255,255,0.35);
          text-decoration: none;
          transition: color 0.2s;
        }
        .mih-footer-link:hover { color: rgba(255,255,255,0.7); }
        .mih-footer-contact-item {
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          color: rgba(255,255,255,0.35);
          margin-bottom: 6px;
          line-height: 1.5;
        }
        .mih-footer-bottom {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          flex-wrap: wrap;
        }
        .mih-footer-bottom-left {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        .mih-footer-copy {
          font-family: monospace;
          font-size: 8px;
          letter-spacing: 0.12em;
          color: rgba(255,255,255,0.15);
        }
        .mih-footer-haal-link {
          font-family: monospace;
          font-size: 8px;
          letter-spacing: 0.12em;
          color: rgba(147,197,253,0.3);
          text-decoration: none;
          transition: color 0.2s;
        }
        .mih-footer-haal-link:hover { color: rgba(147,197,253,0.6); }
        .mih-footer-donate-btn {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 10px 20px;
          background: rgba(37,99,235,0.12);
          border: 1px solid rgba(37,99,235,0.25);
          color: rgba(147,197,253,0.7);
          font-family: monospace;
          font-size: 8px;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          text-decoration: none;
          transition: all 0.2s;
        }
        .mih-footer-donate-btn:hover { background: rgba(37,99,235,0.2); border-color: rgba(37,99,235,0.4); }
        @media (max-width: 900px) {
          .mih-footer-top { grid-template-columns: 1fr 1fr; gap: 28px; }
          .mih-footer { padding: 40px 20px 24px; }
        }
        @media (max-width: 600px) {
          .mih-footer-top { grid-template-columns: 1fr; }
        }
      `}</style>
      <footer className="mih-footer" id="mih-footer" role="contentinfo" aria-label="Masjid Al-Ihsan footer">
        <div className="mih-footer-inner">
          <div className="mih-footer-top">
            {/* Brand */}
            <div>
              <span className="mih-footer-brand-ar">مَسْجِد الإِحْسَان</span>
              <span className="mih-footer-brand-en">Masjid Al-Ihsan · Bronzeville, Chicago</span>
              <p className="mih-footer-brand-body">
                Al-Ihsan — excellence in worship and service. Serving the Muslim community of Bronzeville under the guidance of Imam Abdullah Madyun. A Haal Project Subhaal.
              </p>
              <div className="mih-footer-subhaal-badge">
                <div className="mih-footer-subhaal-dot" />
                <span className="mih-footer-subhaal-text">Haal Project Subhaal</span>
              </div>
            </div>

            {/* Masjid Links */}
            <div>
              <p className="mih-footer-col-title">Masjid</p>
              <div className="mih-footer-links">
                <Link href="/subhaal/masjid-al-ihsan" className="mih-footer-link">Home</Link>
                <Link href="/subhaal/masjid-al-ihsan/about-imam" className="mih-footer-link">Imam Madyun</Link>
                <Link href="/subhaal/masjid-al-ihsan/services" className="mih-footer-link">Services</Link>
                <Link href="/subhaal/masjid-al-ihsan/events" className="mih-footer-link">Events</Link>
                <Link href="/subhaal/masjid-al-ihsan/announcements" className="mih-footer-link">Announcements</Link>
                <Link href="/subhaal/masjid-al-ihsan/contact" className="mih-footer-link">Contact</Link>
              </div>
            </div>

            {/* Resources */}
            <div>
              <p className="mih-footer-col-title">Resources</p>
              <div className="mih-footer-links">
                <Link href="/subhaal/masjid-al-ihsan/resource-guide" className="mih-footer-link">Muslim Resource Guide</Link>
                <Link href="/subhaal/masjid-al-ihsan/resource-guide#caretaker-mata" className="mih-footer-link">Caretaker Mata</Link>
                <Link href="/subhaal/masjid-al-ihsan/resource-guide#justice-involved" className="mih-footer-link">Justice-Involved</Link>
                <Link href="/muslim-resource-guide" className="mih-footer-link">Haal Project MRG</Link>
                <Link href="/subhaal" className="mih-footer-link">All Subhaals</Link>
              </div>
            </div>

            {/* Contact */}
            <div>
              <p className="mih-footer-col-title">Contact</p>
              <p className="mih-footer-contact-item">321 E Pershing Rd<br />Bronzeville, Chicago, IL 60653</p>
              <p className="mih-footer-contact-item">Jumu&apos;ah: 1:00 PM Fridays</p>
              <a
                href="https://www.paypal.com/donate/?hosted_button_id=77VKUXARNLLHJ"
                target="_blank"
                rel="noopener noreferrer"
                className="mih-footer-donate-btn"
                style={{ marginTop: 12 }}
              >
                ◈ Donate
              </a>
            </div>
          </div>

          <div className="mih-footer-bottom">
            <div className="mih-footer-bottom-left">
              <span className="mih-footer-copy">© {new Date()?.getFullYear()} Masjid Al-Ihsan · Islamic Institute of Urban Affairs · Bronzeville, Chicago</span>
              <Link href="/homepage" className="mih-footer-haal-link">↗ The Haal Project — haalproject.org</Link>
            </div>
            <a
              href="https://www.paypal.com/donate/?hosted_button_id=77VKUXARNLLHJ"
              target="_blank"
              rel="noopener noreferrer"
              className="mih-footer-donate-btn"
            >
              ◈ Support the Masjid
            </a>
          </div>
        </div>
      </footer>
    </>
  );
}
